import ky from 'ky';
import getRemoteURL from '../../get-remote-url';

export interface UploadCredentials {
  bucket: string;
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
  prefix: string;
  endpoint?: string;
  region?: string;
  storageProvider: string;
}

export default async function getUploadCreds() {
  const credentialsURL = getRemoteURL('api/user/upload-credentials');
  const uploadCredentials = (await ky
    .get(credentialsURL, { credentials: 'include' })
    .json()) as UploadCredentials;
  return uploadCredentials;
}
